<template>
  <div class="titlePagination">
    <div class="tableTotal">共{{ total }}条</div>
    <el-button size="small" class="upAndDown" style="margin-right: 0px" @click="pervious"
      >上一页</el-button
    >
    <el-pagination
      @current-change="handleCurrentChange"
      :pager-count="paginations"
      :current-page="pageNumber"
      :page-size="Number(pageSize)"
      layout="pager"
      :total="total"
      ref="pageGroup"
    >
    </el-pagination>
    <el-input v-if="isPageSizes" v-model="pageSizeNumber" @input="handleSizeChange">
      <template slot="append">条每页</template>
    </el-input>
    <el-button size="small" class="upAndDown" style="margin-left: 0px" @click="next"
      >下一页</el-button
    >
    <div class="leap" v-show="!showJump">
      <span>跳至</span>
      <el-input v-model="jumpToNumber"></el-input>
      <el-button size="small" class="upAndDown" style="margin-left: 0px" @click="jump"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  // pageNum     //当前显示的页面页码数
  // pageSize    //一页多少条数据
  // isPageSizes   //是否展示控制每页显示多少条
  // total       //总页数
  // jumpTo      //跳转数
  // paginations //折叠多余
  // showJump    //是否显示跳转

  props: ["pageNum", "pageSize", "isPageSizes", "total", "jumpTo", "pagination", "showJump"],
  data() {
    return {
      pageNumber: this.pageNum,
      jumpToNumber: this.jumpTo,
      pageSizeNumber: this.pageSize,
      paginations: this.pagination ? this.pagination : 5,
      timer: null,
    };
  },
  watch: {
    pageNum(newValue, oldValue) {
      this.pageNumber = newValue;
    },
    jumpTo(newValue, oldValue) {
      this.jumpToNumber = newValue;
    },
    pageSize(newValue, oldValue) {
      this.pageSizeNumber = newValue;
    },
  },
  methods: {
    common() {
      if (this.isPageSizes)
        this.$emit("currentChange", {
          page: parseInt(this.jumpToNumber),
          limit: this.pageSizeNumber,
        });
      else this.$emit("currentChange", parseInt(this.jumpToNumber));
    },
    // 点击页码数跳转
    handleCurrentChange(val) {
      let number = 0;
      if (!val) {
        number = 0;
      } else {
        number = val;
      }
      this.jumpToNumber = number;
      this.common();
    },
    handleSizeChange(value) {
      value = parseInt(value);
      if (isNaN(value)) value = 10;
      if (value > this.total || value < 0) value = 10;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.pageSizeNumber = value;
        this.common();
      }, 1000);
    },
    // 上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    // 下一页
    next() {
      this.$refs.pageGroup.next();
    },
    // 跳至
    jump() {
      if (
        this.total / this.pageSize >= Number(this.jumpToNumber) &&
        Number(this.jumpToNumber) != 0
      ) {
        this.pageNumber = Number(this.jumpToNumber);
      } else if (this.total / this.pageSize < Number(this.jumpToNumber)) {
        this.pageNumber = Math.ceil(this.total / this.pageSize);
        this.jumpToNumber = Math.ceil(this.total / this.pageSize);
      }
      this.common();
    },
  },
};
</script>

<style lang="scss" scoped>
// 底部的分页
.titlePagination {
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
}
.tableTotal {
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 14px;
}

// 上下翻页按钮
.upAndDown {
  background: rgba(46, 62, 99, 0.39);
  border: 0px;
  color: #fff;
  height: 32px;
  margin: 2px 15px 0px;
}

// 最右边的跳至
.leap {
  display: flex;
  justify-content: center;
  align-items: center;
}
.leap span {
  display: inline-block;
  width: 40px;
  color: #fff;
  font-size: 14px;
}
.leap .el-input {
  width: 40px;
  height: 32px;
  margin: 0px 15px 0px 5px;
}
.leap ::v-deep .el-input__inner {
  line-height: 32px;
  height: 32px;
  padding: 0px;
  text-align: center;
  background: rgba(46, 62, 99, 0.39);
  border: 0px;
  color: #fff;
}

// 分页中间的数字
.titlePagination ::v-deep .el-pager .number,
.titlePagination ::v-deep .el-icon {
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  margin: 0px 5px;
  background: rgba(46, 62, 99, 0.39);
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
}

.titlePagination ::v-deep .el-pager li:hover {
  color: #fff;
  background: rgba(17, 161, 175, 0.59);
}

.titlePagination ::v-deep .el-pager .active {
  color: #fff;
  background: rgba(17, 161, 175, 0.59);
}

.el-pagination {
  padding: 2px 3px;
}
::v-deep .el-range-editor.is-active,
::v-deep .el-range-editor.is-active:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner,
::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: rgb(27, 246, 248);
}
::v-deep .el-input {
  width: 120px;
  height: 32px;
  margin-left: 10px;
  .el-input-group__append,
  .el-input__inner {
    padding: 0px 5px;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    background: rgba(86, 94, 121, 0.59);
    border-color: rgba(86, 94, 121, 0.59);
    color: #fff;
  }
}
</style>
